import { palette } from '../palette';

declare module '@mui/material/TableCell' {
  interface TableCellPropsVariantOverrides {
    clampedText: true;
    twoLineFullLength: true;
  }
}

export const MuiTable = {
  styleOverrides: {
    root: {
      borderBottom: '1px solid',
      borderTop: '1px solid',
      borderColor: palette.custom.gray[200],
    },
  },
};

export const MuiTableRow = {
  styleOverrides: {
    root: {
      height: '40px',
      minHeight: '40px', // Set the minimum height for the row
      '&.MuiTableRow-hover:hover': {
        cursor: 'pointer',
        backgroundColor: palette.custom.gray[100],
      },
      '&:nth-of-type(even)': {
        backgroundColor: palette.custom.gray[50], // White background for even rows
      },
    },
  },
};


export const MuiTableCell = {
  variants: [
    {
      props: { variant: 'clampedText' },
      style: {
        minWidth: '160px',
        paddingTop: 0,
        paddingBottom: 0,
        '& .MuiTypography-root': {
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          wordBreak: 'break-word',  // optional: allow mid-word break
          hyphens: 'auto',          // optional: hyphenate long words
        },
      },
    },
  ],
  styleOverrides: {
    root: {
      color: palette.custom.gray[600],
      fontWeight: 500,
      fontSize: '12px',

      borderBottom: '1px solid',
      borderBottomColor: palette.custom.gray[200],
      paddingTop: '6px',
      paddingBottom: '6px',
      paddingLeft: '8px',
      paddingRight: '8px',

      height: '40px',
      minHeight: '40px', // Set the minimum height for the cell
      display: 'table-cell', // Ensures proper table layout
      verticalAlign: 'middle', // Aligns content properly
    },
    head: {
      height: '45px',
      color: palette.custom.gray[600],
      fontWeight: 600,
      fontSize: '12px',

      borderBottom: '1px solid',
      borderBottomColor: palette.custom.gray[200],
      backgroundColor: palette.custom.gray[100],
      paddingTop: '8px',
      paddingBottom: '8px',
      paddingLeft: '8px',
      paddingRight: '8px',
    },
  },
};